
import React from 'react';

export default function DisabelCheckedIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="18" height="18" rx="5" fill="var(--disabled-color)" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.5303 3.96967C15.8232 4.26256 15.8232 4.73744 15.5303 5.03033L7.28033 13.2803C6.98744 13.5732 6.51256 13.5732 6.21967 13.2803L2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967C2.76256 8.17678 3.23744 8.17678 3.53033 8.46967L6.75 11.6893L14.4697 3.96967C14.7626 3.67678 15.2374 3.67678 15.5303 3.96967Z"
                fill="white"
            />
        </svg>
    );
}